import { useInviteClientModal } from '@entities/clients/heplers.ts';
import cn from 'classnames';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useWebSettings } from '@shared/hooks';
import { MediumHeader, MediumModal } from '@shared/ui';
import * as st from './styles.module.scss';

export const InviteModal = () => {
  const [copied, setCopied] = useState(false);
  const { closeInviteModal, modalState } = useInviteClientModal();
  const { resource_name } = useWebSettings();

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const recommendUrl = `${window.location.origin}`;

  return (
    <MediumModal isOpen={modalState?.isOpen || false} onRequestClose={closeInviteModal}>
      <MediumHeader title="Оповещение" onClose={closeInviteModal} />

      <div className={st.content}>
        <section className={st.content__data}>
          <div className={st.content__wrapper}>
            <p>{`Приглашаю вас зарегистрироваться на платформе ${resource_name}!`}</p>
            <br></br>
            <p>
              👉 <a href={recommendUrl}>{recommendUrl}</a>
            </p>
            <br></br>
          </div>
        </section>
        <h3 className={st.content__note}>
          *Скопируйте это сообщение и отправьте вашему клиенту любым удобным способом
        </h3>

        <section className={st.submit}>
          <CopyToClipboard
            text={`Приглашаю вас зарегистрироваться на платформе ${resource_name}! \n  👉 ${recommendUrl}`}
            onCopy={onCopy}
          >
            <button>Скопировать</button>
          </CopyToClipboard>
        </section>
      </div>

      <div className={cn(st.message, copied && st.visible)}>Скопировано в буфер обмена</div>
    </MediumModal>
  );
};
